if (document.getElementById('vue-register')) {
	Vue.use(VeeValidate);
	var vm = new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin, MobileValidate],
		el: '#vue-register',
		computed: {},
		created() {
		},
		data: {
			articles: [],
			notifications: [],
			formErrors: [],
			dropdowns: {},
			residences: [],
			steps: [],
			record: {},
			isShortLived: false,
			section: {
				endpoint: 'residence-requests',
				labelSubmit: 'valider',
				title: 'Vos informations',
				fields: {
					residence_1: {
						label: gettext('Choix 1'),
						labelTop: true,
						labelClasses: 'fw-medium c-gray-600',
						component: 'select',
						default: gettext('Sélectionner'),
						options: [],
						model: {},
						validateName: gettext('Choix Résidence 1')
					},
					residence_2: {
						label: gettext('Choix 2'),
						labelTop: true,
						labelClasses: 'fw-medium c-gray-600',
						component: 'select',
						default: gettext('Sélectionner'),
						options: [],
						model: {},
						optional: true
					},
					residence_3: {
						label: gettext('Choix 3'),
						labelTop: true,
						labelClasses: 'fw-medium c-gray-600',
						component: 'select',
						default: gettext('Sélectionner'),
						options: [],
						model: {},
						optional: true
					},
					nb_adults_wish: {
						label: gettext('Adultes'),
						component: 'radio',
						options: [
							{
								label: '1',
								value: '1'
							},
							{
								label: '2',
								value: '2'
							}
						],
						model: { value: '1' }
					},
					nb_children_wish: {
						condition: () => new URLSearchParams(window.location.search).has('short-lived') == false,
						label: gettext('Enfants'),
						component: 'radio',
						options: [
							{
								label: '0',
								value: '0'
							},
							{
								label: '1',
								value: '1'
							},
							{
								label: '2',
								value: '2'
							},
							{
								label: '3',
								value: '3'
							},
							{
								label: '4',
								value: '4'
							}
						],
						model: { value: '0' }
					},
					starting_date_wish: {
						label: gettext("date d'entrée souhaitée"),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'datepicker',
						type: 'date',
						validate: 'date_format:YYYY-MM-DD|date_between:' + getDate() + ',' + getDate(365),
						model: { value: getDate(1) }
					},
					marital_status: {
						label: gettext('situation familiale'),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'select',
						default: gettext('Sélectionner'),
						options: [],
						model: {}
					},
					profession_type: {
						label: gettext('contrat de travail'),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'select',
						default: gettext('Sélectionner'),
						options: [],
						model: {},
						tooltip:
							gettext("Indiquez la situation qui sera la vôtre à la période d'arrivée souhaitée, même si le contrat n'a pas encore débuté")
					},
					nb_dependent: {
						label: gettext('enfants à charge'),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'select',
						default: gettext('Sélectionner'),
						options: [
							{
								label: '0',
								value: '0'
							},
							{
								label: '1',
								value: '1'
							},
							{
								label: '2',
								value: '2'
							},
							{
								label: '3',
								value: '3'
							},
							{
								label: '4',
								value: '4'
							},
							{
								label: '5',
								value: '5'
							},
							{
								label: '6',
								value: '6'
							},
							{
								label: '7',
								value: '7'
							},
							{
								label: '8',
								value: '8'
							},
							{
								label: '9',
								value: '9'
							},
							{
								label: '10',
								value: '10'
							}
						],
						model: { value: 0 },
						tooltip: gettext('Tout enfant mineur ou majeur et rattaché au foyer fiscal')
					},
					incomes_n2: {
						condition: () => new URLSearchParams(window.location.search).has('short-lived') == false,
						label: gettext('revenu fiscal ') + (new Date().getFullYear() - 2),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'input',
						type: 'number',
						model: {},
						tooltip: gettext(" A retrouver en 1ère page de l'avis d'imposition, dans l'encadré \"Vos références\". Si vous êtes ou étiez en couple mais que le/ la conjoint(e) identifié(e) sur votre avis d'imposition n'habitera pas le logement(séparation, mobilité), n'indiquez que votre revenu fiscal et non le sien."),
						onblur: () => { vm.getValidation('income') }
					},
					last_name: {
						label: gettext('nom'),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'input',
						model: {},
						validate: 'max:100'
					},
					first_name: {
						label: gettext('prénom'),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'input',
						model: {},
						validate: 'max:100'
					},
					email: {
						label: gettext('email'),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'input',
						type: 'email',
						model: {},
						validate: 'email'
					},
					mobile_phone_number: {
						label: gettext('téléphone'),
						labelTop: true,
						labelClasses: 'uppercase fw-medium mb-15 c-gray-800',
						component: 'input',
						type: 'tel',
						model: {},
						tooltip:
							gettext("Pour un numéro étranger, merci de préciser l'indicatif / Please indicate the international code if the number is not a French one")
					}
				},
				config: {
					rows: [
						{
							title: gettext('résidences souhaitées'),
							titleClasses: 'uppercase fw-medium mb-15 c-gray-800',
							classes: 'row-xlarge pb-20',
							cols: [
								{
									classes: 'col-md-4',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['residence_1']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['residence_2']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['residence_3']
								}
							]
						},
						{
							title: '',
							classes: 'row-xlarge pb-20',
							cols: [
								{
									title: gettext("nombre d'occupants"),
									titleClasses: 'uppercase fw-medium mb-15 c-gray-800',
									classes: 'col-md-4 mt-20 mt-n-md',
									labelClasses: 'col-md-4 mt-20 mt-n-md self-start',
									fieldClasses: 'col-md-8',
									fields: ['nb_adults_wish', 'nb_children_wish']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['starting_date_wish']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['marital_status']
								}
							]
						},
						{
							title: '',
							classes: 'row-xlarge pb-20',
							cols: [
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['profession_type']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['nb_dependent']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['incomes_n2']
								}
							]
						},
						{
							title: '',
							classes: 'row-xlarge pb-20',
							cols: [
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['last_name']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['first_name']
								},
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['email']
								}
							]
						},
						{
							title: '',
							classes: 'row-xlarge pb-20',
							cols: [
								{
									classes: 'col-md-4 mt-20 mt-n-md',
									// labelClasses: '',
									fieldClasses: 'col-12',
									fields: ['mobile_phone_number']
								}
							]
						}
					]
				}
			},
		},
		watch: {
			'section.fields.residence_1.model.value': function () {
				this.getValidation('residences');
			},
			'section.fields.residence_2.model.value': function () {
				this.getValidation('residences');
			},
			'section.fields.residence_3.model.value': function () {
				this.getValidation('residences');
			},
			'section.fields.nb_adults_wish.model.value': function () {
				this.getValidation('nb_people');
			},
			'section.fields.nb_children_wish.model.value': function () {
				this.getValidation('nb_people');
			},
			'section.fields.profession_type.model.value': function () {
				this.getValidation('status');
			},
			// 'section.fields.incomes_n2.model.value': function() {
			// 	this.getValidation();
			// }
		},
		created() {
			this.$validator.localize(gettext('fr'));
			this.$validator.extend('phone', MobileValidate);
		},
		mounted() {
			const urlParams = new URLSearchParams(window.location.search)
			this.isShortLived = urlParams.has('short-lived')
			this.getDropdowns();
			this.getArticles();
		},
		methods: {
			onInputBlur() {
				console.log('onInputBlur');
			},
			getDropdowns() {
				const residencesUrl = `dropdowns/residence-list${this.isShortLived ? '?short-lived=1' : ''}`
				return axios
					.all([this.get('dropdowns/all', {}, false), this.get(residencesUrl, {}, false)])
					.then(
						axios.spread((dropdowns, residences) => {
							if (dropdowns && dropdowns.data) {
								this.dropdowns = dropdowns.data;
							}
							if (residences && residences.data) {
								this.residences = residences.data;
								this.dropdowns.residence = {
									options: residences.data.map(
										(el) => (residences.data[el] = { label: el.label, value: el.value })
									)
								};
							}
							setTimeout(() => {
								this.section.fields.residence_1.options = this.dropdowns.residence.options;
								this.section.fields.residence_2.options = this.dropdowns.residence.options;
								this.section.fields.residence_3.options = this.dropdowns.residence.options;
								this.section.fields.profession_type.options = this.dropdowns.profession_type.options;
								this.section.fields.marital_status.options = this.dropdowns.marital_status.options;
							}, 1000)
						})
					);
			},
			getValidation(key) {
				let residences = [
					this.section.fields.residence_1.model.value,
					this.section.fields.residence_2.model.value,
					this.section.fields.residence_3.model.value
				].filter((el) => el != '');
				let params = {
					updated_field_key: key,
					income: this.section.fields.incomes_n2.model.value,
					status: this.section.fields.profession_type.model.value,
					nb_people:
						parseInt(this.section.fields.nb_adults_wish.model.value) +
						parseInt(this.section.fields.nb_children_wish.model.value),
					residences: residences.map((el, index) => (el = this.getResidenceById(el).slug)).join()
				};
				this.get('residence-requests/validate-algo', params, false).then((response) => {
					this.notifications = response.data;
					this.notifications.forEach((el) => {
						this.eventHub.$emit('notifications:error', el);
					});
				});
			},
			scroll(id) {
				let to = document.getElementById(id);
				// console.log(to);
				// let element = document.scrollingElement || document.documentElement;
				// let rect = to.getBoundingClientRect();
				VueScrollTo.setDefaults({
					container: 'body',
					duration: 600,
					easing: 'ease',
					offset: 0,
					force: true,
					cancelable: true,
					onStart: false,
					onDone: false,
					onCancel: false,
					x: false,
					y: true
				});
				VueScrollTo.scrollTo(to);
			},
			sendForm(event) {
				event.preventDefault();
				this.$validator.validateAll().then((result) => {
					if (result) {
						let data = { residences: [] };
						Object.keys(this.section.fields).forEach((key) => {
							if (key == 'residence_1' || key == 'residence_2' || key == 'residence_3') {
								if (this.section.fields[key].model.value != '') {
									data['residences'].push(this.section.fields[key].model.value);
								}
							} else {
								data[key] = this.section.fields[key].model.value;
							}
						});
						// console.log(data);
						this.post(this.section.endpoint, data)
							.then((response) => {
								if (window.site_id === 4) {
									window.location = '/candidature/demande-de-logement/' + response.data.id;
								} else {
									window.location = window.registration_redirect_url;
								}
							})
							.catch((error) => {
								if (error.response.status == 500) {
									this.errors.add({ field: "server_error", msg: "Erreur serveur. Veuillez réessayer ultérieurement ou contacter l'équipe de Résidétape." });
								} else {
									Object.keys(error.response.data).map((el) =>
										this.errors.add({
											field: el,
											msg: error.response.data[el][0]
										})
									);
								}

							});
					}
				});
			},
			getResidenceById(id) {
				return this.residences.filter((el) => el.value == id)[0];
			},
			getArticles() {
				this.get('articles', { category__sites: window.site_id }, false)
					.then((response) => {
						this.articles = response.data.results;
						this.$nextTick(() => {
							initCarouselNews();
						});
					})
					.catch((error) => {
						// console.log(error);
					});
			}
		}
	});
}
